import _ from 'underscore';
import { STEP_MANAGER_ACTIONS } from './step-manager-actions';

const defaultStepStatus = {
  isInitialized: false,
  hasUnsavedChange: false,
  errorString: null,
};

export function getInitialState(initialState) {
  const { config } = initialState;
  const stepListSize = _.size(config);
  const statusList = Array(stepListSize).fill(defaultStepStatus);
  const dataList = Array(stepListSize).fill(undefined);
  return {
    stepListSize,
    expandedStepIndex: 0,
    shouldSaveList: Array(stepListSize).fill(false),
    statusList,
    dataList,
  };
}

export function stepManagerReducer(state, action) {
  switch (action.type) {
    case STEP_MANAGER_ACTIONS.COLLAPSE: {
      if (state.expandedStepIndex > -1) {
        const newShouldSaveList = Array(state.stepListSize).fill(false);
        newShouldSaveList[state.expandedStepIndex] = true;
        return {
          ...state,
          expandedStepIndex: -1,
          shouldSaveList: newShouldSaveList,
        };
      }

      return state;
    }

    case STEP_MANAGER_ACTIONS.EXPAND: {
      const { toExpandedStepIndex } = action;
      const expandedStepIndex = Math.min(toExpandedStepIndex, state.stepListSize - 1);
      const shouldSaveList = [...state.shouldSaveList];
      shouldSaveList[expandedStepIndex] = false;
      return {
        ...state,
        expandedStepIndex,
        shouldSaveList,
      };
    }

    case STEP_MANAGER_ACTIONS.UPDATE_STATUS: {
      const { index, status } = action;
      // Make sure unexpected status won't be updated to statusList
      const pickedStatus = _.pick(status, _.keys(defaultStepStatus));
      const newStatus = _.defaults(pickedStatus, state.statusList[index]);

      if (_.isEqual(newStatus, state.statusList[index])) {
        return state;
      }

      const statusList = [...state.statusList];
      statusList.splice(index, 1, newStatus);
      return {
        ...state,
        statusList,
      };
    }

    case STEP_MANAGER_ACTIONS.UPDATE_DATA: {
      const { index, data } = action;
      const dataList = [...state.dataList];
      dataList.splice(index, 1, data);
      return {
        ...state,
        dataList,
      };
    }

    default: throw new Error(`Invalid step manager action: ${action.type}`);
  }
}
